import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import AmchartsDerevo from "../amcharts-derevo/index";
import "../../assets/styles/cards.scss";
import categoryIcons from "./categoryIcons";

class InventoryMainCard extends React.Component {
  constructor(props) {
    super(props);
    this.ws = this.props.ws;
    this.state = {
      data: [],
      productData: [],
      statusData: [],
      topFive: []
    };
    this.branchData = [];
  }
  getObjectByid = async action => {
    await this.ws.connect(action).then(response => {
      this.setState({
        data: this.state.data.concat([response])
      });
    });
  };

  configBars = {
    type: 'simple',
    titles:{
      xAxis: "Category",
      yAxis: "Values",
    },
    colors:{
      max: "#126E81",
      min: "#5EC2B7"
    },
    seriesType: ["ColumnSeries"],
    orientation: 'horizontal',
    configChart: {
      category: 'category',
      value: "value"
    },
    ordering:{
      type: 'asc',
      value: 'value'
    },
    tooltip:{
      text: "{valueX}"
    },
    zoom: false,
    scrollingY: false,
    scrollingX: false
  }
  configStacked = {
    type: 'stacked_bar',
    titles:{
      xAxis: "Year",
      yAxis: "Values",
    },
    // colors:[
    //   "rgba(146, 124, 234, 0.75)",
    //   "rgba(69, 42, 172, 1)"
    // ],
    orientation: 'horizontal',
    configChart: {
      category: 'year'
    },
    tooltip:{
      text:"[ font-size: 15px]{name} {categoryX}:\n[/][ font-size: 20px]{valueX}[/] {additional}",
      pointerOrientation: "left",

    },
    zoom: false,
    scrollingY: false,
    scrollingX: false 
  }

  getData = async () => {
    await this.getObjectByid("getProductInventory");
    await this.getObjectByid("getInventoryStatus");
    await this.getObjectByid("getTopFiveInventory");
    let topFive = [];
   
    if (this.state.data.length > 1) {
      for (let i = 0; i < 5; i++) {
        if (this.state.data[2].data.table[i]) {
          topFive[i] = this.state.data[2].data.table[i];
        } else {
          topFive[i] = {
            category: "N/A",
            articles: "-"
          };
        }
      }
      this.setState({
        productData: await this.state.data[0].data.table.map(data => {
          return { category: data["Descripción"], value: data["Existencia"] };
        }),
        statusData: await this.state.data[1].data.table.map(data => {
          return {
            branch: data["Sucursal"],
            stock: data["Existencia"],
            stockType: data["Tipo stock"]
          };
        }),
        topFive: await topFive.map(data => {
          return {
            category: data["Categoria"],
            articles: data["# Articulos"]
          };
        })
      });

    }
  };
  async componentDidMount() {
    await this.getData();
  }
  async componentWillReceiveProps({ update }) {
    this.setState({
      data: []
    });
    await this.getData();
    this.setState({ ...this.state, update });
  }
  render() {
   
    return (
      <Row>
        <Card className="col-12 border-0">
          <div>
            <Card.Title className="py-4 mb-4 text-center text-sm-left">
              <div className={`top-left-icon bg-inventory inventory-square d-flex align-items-center justify-content-center`}>
                <img alt="" className="img-fluid" src={ require( "../../assets/icons/icon-hand.svg" ) }/>
              </div>
              <span className="ml-sm-5 pl-sm-5 text-muted is-font-weight--extra-bold">INVENTARIOS</span>
            </Card.Title>
            {this.state.topFive.length > 0 ? (
              <div>{this.topFive(this.state.topFive,'inventory')}</div>
            ) : (
              <h2>Cargando...</h2>
            )}

            <Row className="mt-sm-5">
              <Col md={6}>
                {this.state.productData.length > 0 ? (
                  <AmchartsDerevo
                    type={"xy-charts"}
                    data={this.state.productData}
                    id_div="div1"
                    title={""}
                    config={this.configBars}
                    width={""}
                    height={"400px"}
                  />
                ) : (
                  <h2>Cargando...</h2>
                )}
              </Col>
              <Col md={6}>
                {this.state.statusData.length > 0 ? (
                  <AmchartsDerevo
                    id_div={"div2"}
                    type={"xy-charts"}
                    data={this.state.statusData}
                    config={this.configStacked}
                    width={""}
                    height={"400px"}
                  />
                ) : (
                  <h2>Cargando...</h2>
                )}
              </Col>
            </Row>
          </div>
        </Card>
      </Row>
    );
  }


  topFive = (elements,customClass) => {
    return (
      <Row className="justify-content-sm-around">
        <Col xs={6} sm={2} className="text-center text-sm-left mb-3 mb-sm-0">
          {" "}
          <strong className={`text-inventory is-h5 title__${ this.props.customClass }`}>{elements[0].category}</strong>
          <div className="d-flex align-items-center">
            {categoryIcons(elements[0].category)}
            <strong className="is-h2 is-font-montserrat--bold">{elements[0].articles}</strong>
          </div>
        </Col>
        <Col xs={6} sm={2} className="text-center text-sm-left mb-3 mb-sm-0">
          {" "}
          <strong className={`text-inventory is-h5 title__${ this.props.customClass }`}>{elements[1].category}</strong>
          <div className="d-flex align-items-center">
            {categoryIcons(elements[1].category)}
            <strong className="is-h2 is-font-montserrat--bold">{elements[1].articles}</strong>
          </div>
        </Col>
        <Col xs={6} sm={2} className="text-center text-sm-left mb-3 mb-sm-0">
          {" "}
          <strong className={`text-inventory is-h5 title__${ this.props.customClass }`}>{elements[2].category}</strong>
          <div className="d-flex align-items-center">
            {categoryIcons(elements[2].category)}
            <strong className="is-h2 is-font-montserrat--bold">{elements[2].articles}</strong>
          </div>
        </Col>
        <Col xs={6} sm={2} className="text-center text-sm-left mb-3 mb-sm-0">
          {" "}
          <strong className={`text-inventory is-h5 title__${ this.props.customClass }`}>{elements[3].category}</strong>
          <div className="d-flex align-items-center">
            {categoryIcons(elements[3].category)}
            <strong className="is-h2 is-font-montserrat--bold">{elements[3].articles}</strong>
          </div>
        </Col>
        <Col xs={6} sm={2} className="text-center text-sm-left mb-3 mb-sm-0">
          {" "}
          <strong className={`text-inventory is-h5 title__${ this.props.customClass }`}>{elements[4].category}</strong>
          <div className="d-flex align-items-center">
            {categoryIcons(elements[4].category)}
            <strong className="is-h2 is-font-montserrat--bold">{elements[4].articles}</strong>
          </div>
        </Col>
      </Row>
    );
  };
}
export default InventoryMainCard;
